import React from 'react';
import { ColumnInstance } from 'react-table';
import ShimmerWrapper from '@alltrails/shared/components/ShimmerWrapper';
import classNames from 'classnames';

import { COLUMN_ID_CHECKBOX, COLUMN_ID_ACTIONS } from './Table';
import * as styles from './styles/styles.module.scss';

type ShimmerCellProps = {
  column: ColumnInstance<any>;
  short: boolean;
};

const ShimmerCell = ({ column, short }: ShimmerCellProps) => {
  const style = column.getHeaderProps(column.getSortByToggleProps())?.style;

  let shimmerCellClassName = short ? styles.shimmerCellShort : styles.shimmerCellFull;

  if ([COLUMN_ID_ACTIONS, COLUMN_ID_CHECKBOX].includes(column.id)) {
    shimmerCellClassName = styles.shimmerCellCheckbox;
  }

  return (
    <td style={style} className={styles.shimmerTd}>
      <ShimmerWrapper className={styles.shimmerCellContainer}>
        <div className={classNames(styles.shimmerCell, shimmerCellClassName)} />
        {column.id === COLUMN_ID_ACTIONS && <div className={classNames(styles.shimmerCell, shimmerCellClassName)} />}
      </ShimmerWrapper>
    </td>
  );
};

export default ShimmerCell;
